import styled from 'styled-components/macro';

import { COLORS } from 'styleguide';

const PublicationItem = styled.li`
  display: flex;
  height: 130px;
  padding-top: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${COLORS.line};
`;

export default PublicationItem;
